import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useScaleToFit } from '../hooks/useScaleToFit';
import { scrollToForm } from '../utils/scroll';
import { socialProofCards, socialProofStats } from '../data/socialProof';
const AD_SIZE = 1080;
export function SocialProofAd() {
  const {
    ref,
    scale
  } = useScaleToFit(AD_SIZE);
  return <div ref={ref} className="aspect-square w-full overflow-hidden rounded-2xl shadow-brand" data-id="element-313" data-mp="2jin3c1ikldoo">
      <div style={{
      width: AD_SIZE,
      height: AD_SIZE,
      transform: `scale(${scale})`,
      transformOrigin: 'top left'
    }} className="relative overflow-hidden bg-[linear-gradient(160deg,#071F5C_0%,#1B4DCC_100%)] font-sans" data-id="element-314" data-mp="2eja9gwta76cl">
        <div aria-hidden="true" className="pointer-events-none absolute -right-40 -top-40 h-[560px] w-[560px] rounded-full bg-[radial-gradient(circle,rgba(255,213,0,0.12),transparent_70%)]" data-id="element-315" data-mp="y5bprqenmyo2" />

        <div className="relative flex h-[1000px] flex-col px-16 pb-9 pt-12" data-id="element-316" data-mp="5ya46wfood9">
          {/* Encabezado */}
          <header className="text-center" data-id="element-317" data-mp="549ei23ym6o3">
            <p className="font-display text-[40px] font-extrabold leading-tight text-white" data-id="element-318" data-mp="a32vi4iggft0">
              Lo Que Dicen Nuestros
            </p>
            <p className="font-display text-[84px] font-extrabold uppercase leading-none tracking-tight text-brand-yellow" data-id="element-319" data-mp="eub5b1np636p">
              Clientes
            </p>
            <span aria-hidden="true" className="mx-auto mt-3 block h-2.5 w-[300px] rounded-full bg-brand-yellow" data-id="element-320" data-mp="ntogpzvdt1u2" />
            <div className="mt-4 flex justify-center gap-1.5 text-brand-yellow" aria-label="5 de 5 estrellas" data-id="element-321" data-mp="su3psf8mrn68">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} style={{
              fontSize: 40
            }} data-id="element-322" data-mp="2un0eh4vgqo8t" data-mpi={index} />)}
            </div>
          </header>

          {/* Tarjetas + contadores */}
          <div className="mt-8 flex flex-1 items-center gap-10" data-id="element-323" data-mp="2rju6lpoa7z28">
            <div className="flex flex-1 flex-col gap-5" data-id="element-324" data-mp="2nhqwp5h9h2j2">
              {socialProofCards.map(card => <article key={card.id} className="rounded-[20px] bg-white p-6 shadow-[0_18px_40px_rgba(4,16,50,0.35)]" data-id="element-325" data-mp="31hrxkkxj09yj">
                  <div className="flex items-center gap-4" data-id="element-326" data-mp="3ahx30pj5sya2">
                    <span className="flex h-[54px] w-[54px] flex-shrink-0 items-center justify-center rounded-full bg-[linear-gradient(135deg,#1B4DCC,#FFD500)] font-display text-[20px] font-extrabold text-white" data-id="element-327" data-mp="3agdmqyxi6n8a">
                      {card.initials}
                    </span>
                    <div className="min-w-0" data-id="element-328" data-mp="3f9okmakc7to2">
                      <p className="font-display text-[22px] font-extrabold leading-tight text-ink" data-id="element-329" data-mp="3fazn8721qvdl">
                        {card.name}
                      </p>
                      <p className="text-[16px] font-semibold text-brand-blue" data-id="element-330" data-mp="3p84905rzcotv">
                        {card.role}
                      </p>
                    </div>
                    <div className="ml-auto flex flex-shrink-0 gap-0.5 text-brand-yellow" aria-label="5 de 5 estrellas" data-id="element-331" data-mp="gpc0tkdfo897">
                      {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} style={{
                    fontSize: 20
                  }} data-id="element-332" data-mp="7q8iwjq05ywa" data-mpi={index} />)}
                    </div>
                  </div>

                  <div className="mt-3 flex items-end gap-4" data-id="element-333" data-mp="3tvlwbnr8hdeq">
                    <blockquote className="text-[21px] font-medium leading-[1.35] text-ink" data-id="element-334" data-mp="3tx6stix3z6f8">
                      “{card.quote}”
                    </blockquote>
                    <span className="flex-shrink-0 whitespace-nowrap rounded-full bg-brand-green/15 px-4 py-1.5 text-[15px] font-bold text-[#14803D]" data-id="element-335" data-mp="3l3tn1gdy4abq">
                      {card.packageBadge}
                    </span>
                  </div>
                </article>)}
            </div>

            <aside className="flex w-[210px] flex-shrink-0 flex-col gap-7 border-l-2 border-white/15 pl-8" data-id="element-336" data-mp="i9uj6dked3uw">
              {socialProofStats.map(stat => <div key={stat.id} data-id="element-337" data-mp="8k17zdo62qr6">
                  <p className="font-display text-[58px] font-extrabold leading-none text-brand-yellow" data-id="element-338" data-mp="8j9lcscjs3d1">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-[18px] font-medium leading-snug text-white/80" data-id="element-339" data-mp="3usaki9czezzn">
                    {stat.label}
                  </p>
                </div>)}
            </aside>
          </div>

          {/* CTA */}
          <div className="mt-7 flex justify-center" data-id="element-340" data-mp="3lrmhe9p4mk1j">
            <button type="button" onClick={scrollToForm} className="inline-flex items-center gap-3 rounded-full bg-brand-yellow px-12 py-5 font-display text-[30px] font-extrabold text-brand-deep transition hover:bg-brand-yellow-dark" data-id="element-341" data-mp="3gs9kew4jjwl8">
              <RocketLaunchIcon style={{
              fontSize: 32
            }} data-id="element-342" data-mp="1mk5tyepxsdl3" />
              Cotiza en 60 Seg →
            </button>
          </div>
        </div>

        {/* Banner inferior */}
        <div className="flex h-20 items-center justify-center bg-brand-deep px-16 text-center text-[22px] font-semibold text-white" data-id="element-343" data-mp="1rh5xahvej28i">
          Ultimate Web Creator · Webs desde $600 · Listas en 7 días.
        </div>
      </div>
    </div>;
}